import { useCallback, useState } from "react";

export const useSessionStorage = (key, overwriteValue) => {
  assertSessionStoragePermissions();

  // if overwriteValue is passed in, we set it as the current value
  if (overwriteValue || overwriteValue === "") {
    sessionStorage.setItem(key, overwriteValue);
  }

  const [state, setState] = useState(sessionStorage.getItem(key) || "");

  const setNewState = useCallback(
    (newState) => {
      sessionStorage.setItem(key, newState);
      setState(sessionStorage.getItem(key));
    },
    [key]
  );

  return [state, setNewState];
};

export function SessionStoragePermissionError(error) {
  this.name = "SessionStoragePermissionError";
  this.message = error.message;
  this.stack = error.stack;
}

export const assertSessionStoragePermissions = (ss) => {
  try {
    // this is enough to trigger the error
    const storage = ss || sessionStorage;
    storage.length;
  } catch (err) {
    throw new SessionStoragePermissionError(err);
  }
};
